/**
 * Note Road Detection Hook
 *
 * Thin wrapper over the shared `useRoadDetection` core. Reads the form anchor
 * point from the notes slice (`state.notes.formAnchorPoint`) and delegates GPS
 * detection + manual input for the country-aware `RoadDisplayField`.
 */
import { useGeoMarkupStore } from '@/store';
import { useRoadDetection } from '@/hooks/useRoadDetection';
import type { useGPSLocationSuggestion } from '@/hooks/useGPSLocationSuggestion';
import type { RoadSource } from '@/components/common/RoadDisplayField';

interface UseNoteRoadDetectionProps {
  gpsLocationSuggestion: ReturnType<typeof useGPSLocationSuggestion>;
  setLocation: (value: string) => void;
}

interface UseNoteRoadDetectionReturn {
  roadSource: RoadSource;
  handleRequestGPSDetection: () => void;
  handleManualRoadInput: (value: string) => void;
}

export function useNoteRoadDetection({
  gpsLocationSuggestion,
  setLocation,
}: UseNoteRoadDetectionProps): UseNoteRoadDetectionReturn {
  const anchorLat = useGeoMarkupStore(
    (state) => state.notes.formAnchorPoint?.lat ?? null
  );
  const anchorLng = useGeoMarkupStore(
    (state) => state.notes.formAnchorPoint?.lng ?? null
  );

  return useRoadDetection({
    anchorLat,
    anchorLng,
    gpsLocationSuggestion,
    setLocation,
  });
}
